import { useSelector } from "react-redux";
import { getClubColor, getIconForType, getTimeAgo } from "../../common/logics";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const NotificationItem = ({ notification, onClose }:any) => {
  const [isHovered, setIsHovered] = useState(false);
  const [t] = useTranslation();
  const Icon = getIconForType(notification.type);
  const isAdmin = useSelector((state:any) => state?.common?.isAdmin);
  const myClubs = useSelector((state: any) => state.common.myClubs);

  const handleReadToggle = () => {
    // console.log('Navigate to:', notification.route);
    onClose({...notification, isRead: !notification?.isRead});
  };

  const handleNavigate = () => {
    // console.log('Navigate to:', notification.route);
  };

  const fetchClubLogo = (clubId: any) => {
    const club = myClubs.find((c: any) => c.id == clubId);
    return club ? club.imageUrl : '';
  }

  return (
    <div
      onClick={handleNavigate}
      style={{
        display: 'flex',
        padding: '16px 20px',
        cursor: 'pointer',
        backgroundColor: notification.isRead ? 'transparent' : '#f0f7ff',
        borderBottom: '1px solid #e0e0e0',
        transition: 'background-color 0.2s',
        position: 'relative',
      }}
      onMouseEnter={(e) => {
        setIsHovered(true);
        e.currentTarget.style.backgroundColor = notification.isRead ? '#f5f5f5' : '#e3f2fd';
      }}
      onMouseLeave={(e) => {
        setIsHovered(false);
        e.currentTarget.style.backgroundColor = notification.isRead ? 'transparent' : '#f0f7ff';
      }}
    >
      <div style={{ position: 'relative', marginRight: '16px', flexShrink: 0 }}>
        <div
          style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: '#e3f2fd',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#1976d2',
          }}
        >
          <Icon size={24} />
        </div>
        {
          isAdmin &&
          <div
            style={{
              position: 'absolute',
              top: '-3px',
              left: '-3px',
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              // backgroundColor: clubColor,
              // border: '3px solid white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '10px',
              fontWeight: 'bold',
              // color: 'white',
            }}
          >
              <img src={`https://jamp.football${fetchClubLogo(notification.clubId)}`} alt="clubICon" width={'20px'} />
          </div>
        }
      </div>
      <div style={{ flex: 1, minWidth: 0, paddingRight: '8px' }}>
        <div
          style={{
            fontWeight: 600,
            color: '#2c3e50',
            fontSize: '15px',
            marginBottom: '4px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            // whiteSpace: 'nowrap',
            textAlign: 'left',
            width: '220px'
          }}
        >
          {notification.title}
        </div>
        <div
          style={{
            color: '#95a5a6',
            fontStyle: 'italic',
            fontSize: '14px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            lineHeight: '1.4',
            textAlign: 'left',
          }}
        >
          {notification.description}
        </div>
      </div>
      <div
        style={{
          position: 'absolute',
          top: '16px',
          right: '20px',
          color: '#b0b0b0',
          fontSize: '12px',
          whiteSpace: 'nowrap',
        }}
      >
        {getTimeAgo(notification.updatedDate)}
      </div>
        {isHovered && (
          <button
            className="read-toggle-btn"
            onClick={handleReadToggle}
            style={{
              padding: '4px 12px',
              fontSize: '11px',
              fontWeight: 600,
              color: notification.isRead ? '#1976d2' : '#666',
              backgroundColor: notification.isRead ? '#e3f2fd' : '#f5f5f5',
              border: `1px solid ${notification.isRead ? '#1976d2' : '#ddd'}`,
              borderRadius: '12px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              whiteSpace: 'nowrap',
              height: '20px',
              marginTop: 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = notification.isRead ? '#bbdefb' : '#e0e0e0';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = notification.isRead ? '#e3f2fd' : '#f5f5f5';
            }}
          >
            {notification.isRead ? t('MARK_AS_UNREAD') : t('MARK_AS_READ')}
          </button>
        )}
    </div>
  );
};

export default NotificationItem;